import { LoyaltyAuthenticationType } from '../../configuration/types/loyalty/loyalty-authentication-type';
import { refreshMemberAuthenticationToken } from '../../domains/loyalty/actions/member/authentication/refresh-member-authentication-token';
import { shouldRefreshAuthToken } from './should-refresh-auth-token';
/**
 * Creates an [[OcapiLoyaltyAuthTokenProvider]] with caching to prevent unnecessary client `getToken` and `setToken` calls.
 */
export const createOcapiLoyaltyAuthTokenProvider = (config) => {
    if (config.type === LoyaltyAuthenticationType.Cookie)
        return undefined;
    let authTokenPromise;
    const getAuthToken = async () => {
        // Get the token from the configured storage each time to prevent any out-of-sync issues.
        let authToken = await config.getToken();
        if (!authToken)
            return undefined;
        // Refresh the access token if it needs to be refreshed.
        const refresh = shouldRefreshAuthToken(authToken.access_token);
        if (refresh)
            authToken = await refreshMemberAuthenticationToken(authToken);
        return authToken;
    };
    return async () => {
        // Return the cached promise to prevent duplicate API calls.
        if (!authTokenPromise)
            authTokenPromise = getAuthToken();
        const token = await authTokenPromise;
        // Clear the cached promise and return the auth token.
        authTokenPromise = undefined;
        return token;
    };
};
